import axios from "axios";
import User from "../models/user";
import authHeader from "./auth-header";
import { ApiService } from "@/services/api.service";
import { Voucher } from "@/models/voucherI";
import environments from "../utils/environments";

const API_URL = environments.apiUrl + "/api/vouchers";

class VoucherService {

// Voucher CRUD

  createVoucher(data: any) {
    return ApiService.post(API_URL + "/create", data);
  }

  editVoucher(data: any) {
    return ApiService.post(API_URL + "/update", data);
  }

  getOpenVouchers() {
    return ApiService.post(API_URL + "/open", {});
  }

  getAllVouchersForTracking() {
    return ApiService.post(API_URL + "/tracking", {});
  }

  getVoucherArchive() {
    return ApiService.get(API_URL + "/archived");
  }

  getVoucherDetails(voucherId: any) {
    return ApiService.post(API_URL + "/detail", { voucherId: voucherId });
  }

  getVouchersForVendor(vendorId: number) {
    return ApiService.post(API_URL + "/vendor", { vendorId: vendorId });
  }

  // Voucher Actions

  approveVoucher(data: any) {
    return ApiService.post(API_URL + "/action/approve", data);
  }

  archiveVoucher(data: any) {
    return ApiService.post(API_URL + "/action/archive", data);
  }

  declineVoucher(data: any) {
    return ApiService.post(API_URL + "/action/decline", data);
  }

  exportVoucherTrackingData(createDateFrom: any, createDateUntil: any) {
    return ApiService.gets(
      API_URL +
        "/action/export/aims?createDateFrom=" +
        createDateFrom +
        "&createDateUntil=" +
        createDateUntil
    );
  }

  excelExport(voucherIds: string) {
    return ApiService.gets(API_URL + "/action/excel?voucherIds=" + voucherIds);
  }

  parkVoucher(data: any) {
    return ApiService.post(API_URL + "/action/park", data);
  }

  unparkVoucher(data: any) {
    return ApiService.post(API_URL + "/action/unpark", data);
  }
}

export default new VoucherService();
